<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position: relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters
              v-model="filterOptions"
              style="margin-right: 45px"
              @click="refresh"
            />
            <DropdownColumns
              v-model="fields"
              class="customize"
              :export-link="exportLink"
              :export-json="exportJson"
            />
          </div>
          <b-table
            id="shops-table"
            :busy.sync="isBusy"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :hover="true"
            :striped="true"
            stacked="md"
            v-model="copy"
            :items="provider"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @row-clicked="rowClicked"
            tbody-tr-class="tr-pointer"
            v-columns-resizable="{ afterResize: columnsWidthChanged }"
          >
            <template v-slot:empty="scope">
              <div class="text-center">{{ $t(scope.emptyText) }}</div>
            </template>

            <template v-slot:head(core_location_id)="data">{{
              $t(data.label)
            }}</template>
            <template v-slot:head(etenant_id)="data">{{
              $t(data.label)
            }}</template>
            <template v-slot:head(code)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(city)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(county)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(country)="data">{{
              $t(data.label)
            }}</template>
            <template v-slot:head(status)="data">{{ $t(data.label) }}</template>

            <template v-slot:cell(etenant_id)="data">
              <span v-if="data.value.to">
                <router-link :to="`/tenants/${data.value.to}`">{{
                  data.value.name
                }}</router-link>
              </span>
              <span v-else>{{ data.value.name }}</span>
            </template>

            <template v-slot:cell(efirewall_ruleset_id)="data">
              <span v-if="data.value.to">
                <router-link :to="`/firewalls/${data.value.to}`">{{
                  data.value.name
                }}</router-link>
              </span>
              <span v-else>{{ data.value.name }}</span>
            </template>

            <template v-slot:head(selected)>
              <label
                class="
                  kt-checkbox
                  kt-checkbox--single
                  kt-checkbox--all
                  kt-checkbox--solid
                "
              >
                <input
                  type="checkbox"
                  @click.stop
                  @change="selectAll"
                  v-model="checkAll"
                />
                <span></span>
              </label>
            </template>
            <template v-slot:cell(selected)="data">
              <label
                class="
                  kt-checkbox
                  kt-checkbox--single
                  kt-checkbox--all
                  kt-checkbox--solid
                "
              >
                <input
                  type="checkbox"
                  @click.stop
                  :value="data.item.eid"
                  v-model="selected"
                />
                <span></span>
              </label>
            </template>
          </b-table>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space: nowrap" class="my-2">
                <BulkActionSelect
                  v-model="bulkAction"
                  :options="bulkActionOptions"
                  variant="light"
                  class="mr-2"
                  size="sm"
                  v-if="selected.length"
                />
                <b-button
                  @click.stop="applySelected()"
                  size="sm"
                  class="mr-2 refresh"
                  variant="light"
                  v-if="selected.length"
                  :disabled="!bulkAction"
                  >{{ $t("Apply") }}</b-button
                >
                <span class="pagination-sep" v-if="selected.length"></span>
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{
                      (currentPage - 1) * perPage + 1
                    }}</span>
                    <span slot="end">{{ currentPage * perPage }}</span>
                    <span slot="total">{{ totalRows }}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'shops-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import BulkActionSelect from "@/components/BulkActionSelect";

export default {
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters,
    BulkActionSelect,
  },
  name: "Shops",
  mixins: [tableMixin],
  data: function () {
    return {
      tableName: "shops",

      bulkAction: null,
      bulkActionOptions: [
        { text: "Activate Shops", field: "status", value: "active" },
        { text: "Inactivate Shops", field: "status", value: "inactive" },
        { text: "Block Shops", field: "status", value: "blocked" },
        {
          text: "Allow Print Duplicate",
          field: "allow_print_duplicate",
          value: true,
        },
        {
          text: "Prevent Print Duplicate",
          field: "allow_print_duplicate",
          value: false,
        },
        { text: "Enable Test", field: "test", value: true },
        { text: "Disable Test", field: "test", value: false },
      ],

      filterOptions: [
        {
          field: "tenant_id",
          multiple: false,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          options: [
            // {
            //   all_shops_id: "SN3Esh88ppeQiJu-0pQFfQ",
            //   brand_name: "MAGNUM",
            //   ecompany_id: "idHLDlcZlgL94MRmVts1dQ",
            //   eid: "idHLDlcZlgL94MRmVts1dQ"
            // }
          ],
          selected: [],
        },
        {
          field: "firewall_ruleset_id",
          multiple: false,
          placeholder: "Firewall",
          trackBy: "eid",
          label: "name",
          store: "firewalls",
          translate: false,
          options: [
            {
              eid: "idHLDlcZlgL94MRmVts1dQ",
              name: "general",
            },
          ],
          selected: [],
        },
        {
          field: "status",
          multiple: true,
          placeholder: "Status",
          options: [
            { name: "Active Shops", value: "active" },
            { name: "Inactive Shops", value: "inactive" },
            { name: "Blocked Shops", value: "blocked" },
          ],
          selected: [],
        },
      ],

      isBusy: false,
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "selected",
          selected: false,
          ignore: true,
          class: "mw-select",
          dpIgnore: true,
        },
        {
          key: "eid",
          label: "Id",
          sortable: false,
          class: "d-none",
          ignore: true,
        },
        {
          key: "core_location_id",
          label: "Location ID",
          sortable: false,
          class: "d-none",
          ignore: true,
        },
        {
          key: "etenant_id",
          label: "Tenant",
          sortable: true,
          class: "",
          ignore: true,
        },
        { key: "code", sortable: true, class: "" },
        { key: "name", sortable: true, class: "" },
        { key: "address", sortable: true, class: "d-none" },
        { key: "city", sortable: true, class: "" },
        { key: "county", sortable: true, class: "" },
        { key: "country", sortable: true, class: "" },
        { key: "status", sortable: true, class: "", ignore: true },
        {
          key: "allow_print_duplicate",
          sortable: true,
          class: "d-none",
          ignore: true,
        },
        {
          key: "efirewall_ruleset_id",
          label: "Firewall",
          class: "d-none",
          ignore: true,
        },
        {
          key: "sbt_number",
          label: "Self Betting Terminals Number",
          class: "d-none",
          ignore: true,
        },
        {
          key: "tills_number",
          label: "Tills Number",
          class: "d-none",
          ignore: true,
        },
        { key: "test", class: "d-none", ignore: true },
        { key: "online", class: "d-none", ignore: true },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      selected: [],
      copy: null,
      addLabel: "Add shop",
    };
  },
  watch: {
    selected(val) {
      if (val.length != this.copy.length) {
        this.checkAll = false;
      }
    },
  },
  computed: {
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      //const endpoint = this.$store.getters["shop/endpoint"];

      return `${apiUrl}/shops?export=xls&lang=${this.lang}`;
    },
    exportJson() {
      const fields = [];
      this.fields.forEach(item => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          if (key != "selected") {
            const efields = [
              "eshop_id",
              "etenant_id",
              "ecompany_id",
            ];

            if (efields.indexOf(key) > -1) {
              key = key.substr(1);
            }

            fields.push(key);
          }
        }
      });

      const paginationData = this.buildPagination();

      paginationData.fields = fields;

      return JSON.stringify(paginationData);
    }
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "shops-table");
    },
    selectAll() {
      this.selected = [];
      this.copy.forEach((item) => {
        if (this.checkAll) {
          this.selected.push(item.eid);
        }
      });
    },
    applySelected() {
      const loading = this.$loading.open({
        container: this.$refs.cnt,
      });

      const bulkData = {
        field: this.bulkAction.field,
        value: this.bulkAction.value,
        ids: this.selected,
      };

      this.$store.dispatch("shop/bulkAction", bulkData).finally(() => {
        loading.close();
        this.allSelected = false;
        this.selected = [];
        this.refresh();
      });
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        let sortBy = this.sortBy;
        if (sortBy == "etenant_id") sortBy = "tenant_id";
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach((item) => {
        if (item.selected.length) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach((el) => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      return paginationData;
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt,
      });

      const paginationData = this.buildPagination();

      const tenantByID = this.$store.getters["cache/tenantByID"];
      const firewallByID = this.$store.getters["cache/firewallByID"];

      const tenantIDs = {};
      const firewallIDs = {};

      // Promise.all([
      //   this.$store.dispatch("cache/fetch", "tenants").catch(e => e),
      //   this.$store.dispatch("cache/fetch", "firewalls").catch(e => e)
      // ]).finally(() => {
      this.$store
        .dispatch("shop/fetch", paginationData)
        .then((resp) => {
          this.totalRows = resp.data.total;
          resp.data.rows.forEach((item, index) => {
            if (item.status) {
              if (item.status == "active") {
                resp.data.rows[index]["_cellVariants"] = {
                  status: "success",
                };
              } else if (item.status == "blocked") {
                resp.data.rows[index]["_cellVariants"] = {
                  status: "danger",
                };
              } else if (item.status == "inactive") {
                resp.data.rows[index]["_cellVariants"] = {
                  status: "info",
                };
              }
            }
            if (item.etenant_id) {
              tenantIDs[item.etenant_id] = true;
            }
            if (item.efirewall_ruleset_id) {
              firewallIDs[item.efirewall_ruleset_id] = true;
            }
          });
          // TODO promise all
          Promise.all([
            this.$store.dispatch("cacheOnDemand/fetch", {
              key: "tenants",
              ids: Object.keys(tenantIDs),
            }),
            this.$store.dispatch("cacheOnDemand/fetch", {
              key: "firewalls",
              ids: Object.keys(firewallIDs),
            }),
          ])
            .then(([tenantsData, firewallsData]) => {
              resp.data.rows.forEach((item) => {
                if (item.etenant_id) {
                  item.etenant_id = {
                    to: item.etenant_id,
                    name: tenantsData[item.etenant_id].brand_name,
                  };
                }
                if (item.efirewall_ruleset_id) {
                  item.efirewall_ruleset_id = {
                    to: item.efirewall_ruleset_id,
                    name: firewallsData[item.efirewall_ruleset_id].name,
                  };
                }
              });
            })
            .catch((err) => {
              this.$bvToast.toast(
                this.$t(err.message),
                errorConf(this.$t("Error"))
              );
            });
          callback(resp.data.rows);
        })
        .catch((err) => {
          this.$bvToast.toast(
            this.$t(err.message),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });
      // });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      this.$router.push("/shops/" + item.eid);
    },
    redirect() {
      this.$router.push("/shops/0");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


